(function () {
  var CAP_PROPERTY_KEY = 'Personalización';
  var PAIR_PROPERTY_KEY = '_addon_pair';
  var ADDON_PROPERTY_KEY = 'Para';

  var isReconciling = false;
  var needsRecheck = false;

  function isAddonLine(line) {
    return !!(line.properties && line.properties[ADDON_PROPERTY_KEY]);
  }

  function isCapLine(line) {
    return !!(line.properties && line.properties[PAIR_PROPERTY_KEY]) && !isAddonLine(line);
  }

  function hasMatchingLine(items, pair, excludeKey, matcher) {
    return items.some(function (line) {
      return line.key !== excludeKey &&
        line.properties &&
        line.properties[PAIR_PROPERTY_KEY] === pair &&
        matcher(line);
    });
  }

  // Addon sin su gorra pareja: el cliente borró la gorra (o la reconciliación de otra
  // pestaña llegó primero). Se elimina; nunca puede quedar solo en el carrito.
  function findOrphanAddonLines(cart) {
    return cart.items.filter(function (line) {
      if (!isAddonLine(line)) return false;
      var pair = line.properties[PAIR_PROPERTY_KEY];
      return !!pair && !hasMatchingLine(cart.items, pair, line.key, isCapLine);
    });
  }

  // Gorra cuyo addon ya no está: el cliente borró sólo el addon. La línea queda con un
  // "Personalización: X" que ya no es cierto y el stepper de cantidad seguiría oculto
  // (atado a _addon_pair). Shopify no permite editar properties de una línea existente,
  // así que se recrea sin las properties del addon.
  function findStaleCapLines(cart) {
    return cart.items.filter(function (line) {
      if (!isCapLine(line)) return false;
      var pair = line.properties[PAIR_PROPERTY_KEY];
      return !hasMatchingLine(cart.items, pair, line.key, isAddonLine);
    });
  }

  function removeLine(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    });
  }

  function stripAddonProperties(properties) {
    var cleaned = {};
    Object.keys(properties || {}).forEach(function (key) {
      if (key === CAP_PROPERTY_KEY || key === PAIR_PROPERTY_KEY) return;
      cleaned[key] = properties[key];
    });
    return cleaned;
  }

  function repairCapLine(line) {
    return removeLine(line).then(function () {
      return fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: line.variant_id,
            quantity: line.quantity,
            properties: stripAddonProperties(line.properties)
          }]
        })
      });
    });
  }

  function reconcile() {
    if (isReconciling) {
      needsRecheck = true;
      return;
    }
    isReconciling = true;

    fetch('/cart.js').
    then(function (response) { return response.json(); }).
    then(function (cart) {
      var orphanAddons = findOrphanAddonLines(cart);
      var staleCaps = findStaleCapLines(cart);

      if (!orphanAddons.length && !staleCaps.length) return false;

      var tasks = orphanAddons.map(function (line) {
        return function () { return removeLine(line); };
      }).concat(staleCaps.map(function (line) {
        return function () { return repairCapLine(line); };
      }));

      // Secuencial: el carrito es un recurso mutable único por sesión, y repairCapLine
      // ya es en sí misma una secuencia (borrar, después agregar).
      return tasks.reduce(function (promise, task) {
        return promise.then(task);
      }, Promise.resolve()).then(function () { return true; });
    }).
    then(function (changedSomething) {
      isReconciling = false;
      if (needsRecheck) {
        needsRecheck = false;
        reconcile();
      } else if (changedSomething) {
        // Se corrigió al menos una línea: forzar el refresco nativo del carrito para
        // que <cart-form> vuelva a pintar la sección con el DOM ya corregido.
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
        );
      }
    }).
    catch(function () {
      isReconciling = false;
    });
  }

  // Cubre: agregar/quitar/cambiar cantidad (theme:cartchanged), carrito restaurado o
  // vuelta atrás desde el checkout (carga de página).
  document.addEventListener('theme:cartchanged', reconcile);
  document.addEventListener('DOMContentLoaded', reconcile);
  if (document.readyState !== 'loading') reconcile();
})();
